
<template>
  <html>
    <head>
      
    </head>
    <body>
      <navbar></navbar>
       <img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
      />
      
      <div class="title-page-l">
          <img class="icon-t"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
          />
        <p>คะเเนนสะสม</p>
        <h1>87,636</h1>
      </div>
      <div class="contro">
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="container-fluid justify-content-start">
            <div class="btPro">
              <button class="btn btn-outline-success me-2" type="button">
                Promotions 
              </button>
            </div>
            <div class="btDo">
              <button
                class="btn btn-sm btn-outline-secondary me-2"
                type="button"
              >
                Seasonal Menu
              </button>
            </div>
            <div class="btDo2">
              <button
                class="btn btn-sm btn-outline-secondary me-2"
                type="button"
              >
                Cake
              </button>
            </div>
            <div class="line-c">
              <hr class="new4" />
            </div>
            <div class="line-d">
              <hr class="new5" />
            </div>
          </form>
        </nav>
      </div>
      <a class="row bg-white s" href = "ShopView05">
        <div>
          <img
            class="img-profile"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-drink-img-01.jpg"
          />

          <span class="name-status">Dolgona coffee</span>
         
          <br />
          <span class="name-price">Dolgona coffee or whipped instant coffee.</span>

          <br /><span class="name-time">80 B</span>
        </div>
      </a>
      <div class="row bg-white s">
        <div>
          <img
            class="img-profile"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-drink-img-01.jpg"
          />

          <span class="name-status">Dolgona coffee</span>
         
          <br />
          <span class="name-price">Dolgona coffee or whipped instant coffee.</span>

          <br /><span class="name-time">80 B</span>
        </div>
      </div>
      </div>
    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
.contro{
margin-top: 70px;
}
hr.new4 {
  border: 1px solid #848484;
  height: 1px;
  width: 212px;
  border-radius: 73px;
}
.line-c {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
 left: 214px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
}
hr.new5 {
  border: 2.5px solid #ff0000;
  height: 1px;
  width: 164px;
  border-radius: 73px;
  top: 35.1px;
}
.line-d {
display: table;
    top: 32px;
    position: absolute;
    overflow: visible;
    border-radius: 30px;
    left: 50px;
  
    margin-left: auto;
    margin-right: auto;
    border-radius: 30px;
    float: left;

}
.btPro {
  float: left;

  text-align: center;
}
.btDo {
  float: left;

  text-align: center;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: 50px;
}
.btn-outline-success {
  font-family: “Times New Roman”, Times, serif;
  color: #7bc79a;
  border-color: #963c3c00;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
}
.btn-outline-secondary {
  font-family: “Times New Roman”, Times, serif;
  color: #7f8285;
  border-color: #ffffff00;
  font-weight: bold;
  width: 100%;
  float: left;
  font-size: 19px;
}
.navbar {
      position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-top: .5rem;
    padding-bottom: .5rem;
    margin-left: -54px;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 9px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: Prompt SemiBold;
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}

.bg-white.s {
border-radius: 10px;
    height: 122px;
    width: 90%;
    position: relative;
    overflow: visible;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
}


h1 {
    margin-top: 12px;
    margin-left: 52px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
margin-left: 53px;
    margin-top: -48px;
}
.img-profile {
display: block;
    margin-left: 9;
    margin-right: 9;
   
    padding-right: 12px;
    padding-left: -15px;

    margin-left: -11px;
    width: 120px;
    height: 120px;
    float: left;
}
.name-status {
font-family: “Times New Roman”, Times, serif;
    color: #000000;
    margin-top: 13px;
    font-size: 16.3px;
    font-weight: bold;
}
.name-now {
  font-family: “Times New Roman”, Times, serif;
  color: #585858cb;
  margin-top: 13px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {

    color: #898989;

    font-size: 10px;

}
.name-time {
    font-family: “Lucida Console”, Monaco, monospace;
    color: #ff0303;
    margin-top: 32px;
    margin-bottom: 0px;
    font-size: 21px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
</style>

